<script setup=""></script>

<template>
  <svg fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
    <path
      clip-rule="evenodd"
      d="M13.0371 17.0666V26.6666H17.5145V17.1999H20.5433L21.3334 13.1999H17.5145C17.5145 13.1999 17.5145 11.3333 17.5145 10.2666C17.5145 9.86659 17.6462 9.33325 18.3046 9.33325C19.2264 9.33325 20.4116 9.33325 20.4116 9.33325V5.33325C20.4116 5.33325 18.4363 5.33325 16.3293 5.33325C15.0124 5.33325 13.0371 7.06659 13.0371 9.06659C13.0371 11.0666 13.0371 13.1999 13.0371 13.1999H10.6667V17.1999L13.0371 17.0666Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
